<script setup lang="ts">

import { comma } from "@library/Utilities";
import type { ICarbucksProfile } from "@domain/Carbucks";
import { CarbucksAmount } from ".";

const model = defineModel<ICarbucksProfile>( { required: true } );

</script>

<template>

    <div class="tracking-wider"> 

        <div class="flex flex-col items-center w-full py-3 lg:py-4 gap-3 lg:gap-4">

            <CarbucksAmount v-model="model" />

            <Button variant="tonal"
                    :disabled="model.hasCashbackThatCanBeRedeemed == false"
                    class="flex items-center w-48 !h-10 lg:!h-11 rounded-lg my-3"
                    to="/carbucks/redeem-cashback">
                Withdraw
            </Button>
            
            <div class="grid grid-cols-2 w-full gap-0.5">
                <div class="py-1 lg:py-4 pl-2 pr-5 lg:pl-3 text-right">
                    <div class="flex flex-col items-center justify-center">
                        <h1 class="text-sm lg:text-base 3xl:text-xl opacity-60">Lifetime</h1>
                        <h2 class="text-lg lg:text-2xl 3xl:text-4xl leading-tight font-bold">
                            <span class="opacity-80">$</span>{{ comma( model.lifetimeAmount, 2 ) }}
                        </h2>
                    </div>
                </div> 
            
                <div class="py-1 lg:py-4 pl-5 pr-2 lg:pr-3 text-right">
                    <div class="flex flex-col items-center justify-center">
                        <h1 class="text-sm lg:text-base 3xl:text-xl opacity-60">Pending</h1>
                        <h2 class="text-lg lg:text-2xl 3xl:text-4xl leading-tight font-bold">
                            <span class="opacity-80">$</span>{{ comma( model.pendingAmount, 2 ) }}
                        </h2>
                    </div>
                </div>
            </div>
            
        </div>
    </div>

</template>
